import React from "react";
import PropTypes from "prop-types";

export const MEMBER_ATTACHMENT_TEST_IDS = {
  button: "MEMBER_ATTACHMENT_BUTTON_TEST_ID",
  description: "MEMBER_ATTACHMENT_DESCRIPTION_TEST_ID",
  downloadFileIcon: "download-file-icon"
};

const MemberAttachment = ({ title, description, onClick, settings }) => {
  return (
    <div className='member-attachment'>
      <div>
        <p className='title'>{title}</p>
        <p
          data-testid={MEMBER_ATTACHMENT_TEST_IDS.description}
          className='description'
        >
          {" "}
          {description}
        </p>
      </div>
      <button
        type='button'
        data-testid={MEMBER_ATTACHMENT_TEST_IDS.button}
        onClick={e => {
          e.preventDefault();
          onClick();
        }}
        aria-label={`${settings.translations.download_image} ${title}`}
      >
        View
        <div
          className='download-file-web-sdk'
          data-testid={MEMBER_ATTACHMENT_TEST_IDS.downloadFileIcon}
        >
          {" "}
        </div>
      </button>
    </div>
  );
};

MemberAttachment.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  settings: PropTypes.objectOf(PropTypes.object).isRequired
};

export default MemberAttachment;
